export enum SwayOfferTypeEnum {
  LOCAL = 'LOCAL',
  WEB = 'WEB',
  WEB_GIVE_AWAY = 'WEB_GIVE_AWAY',
  RECEIPT_GIVE_AWAY = 'RECEIPT_GIVE_AWAY',
}

export interface SwayOfferType {
  type: SwayOfferTypeEnum
  title: string
}

export const swayOfferTypes = Object.freeze({
  LOCAL: {
    type: SwayOfferTypeEnum.LOCAL,
    title: 'Local',
  } as SwayOfferType,
  WEB: {
    type: SwayOfferTypeEnum.WEB,
    title: 'Web',
  } as SwayOfferType,
  WEB_GIVE_AWAY: {
    type: SwayOfferTypeEnum.WEB_GIVE_AWAY,
    title: 'Web Give Away',
  } as SwayOfferType,
  RECEIPT_GIVE_AWAY: {
    type: SwayOfferTypeEnum.RECEIPT_GIVE_AWAY,
    title: 'Receipt Give Away',
  } as SwayOfferType,
})

export interface SwayOffer {
  id: string
  business_id: string
  creator_app_user_id: string
  expired: Boolean
  offer_summary: string
  offer_type: SwayOfferTypeEnum
  offer_image_url: string | null
  hashtags: Array<string>
  facebook_mentions: Array<string>
  instagram_mentions: Array<string>
}

export interface SwayOfferBase {
  offer_type: SwayOfferTypeEnum
  offer_summary: string
  offer_image_url: string | null
  expiration_description: string | null
  approve_proof_email_template_id: string | null
  deny_proof_email_template_id: string | null
  hashtags: Array<string> | null
  instagram_mentions: Array<string> | null
  facebook_mentions: Array<string> | null
}

export function isGiveAwayOffer(swayOfferType: SwayOfferTypeEnum) {
  return [SwayOfferTypeEnum.RECEIPT_GIVE_AWAY, SwayOfferTypeEnum.WEB_GIVE_AWAY].includes(swayOfferType)
}
